// Loading fallback component for Suspense boundaries
const LoadingFallback = () => {
  return (
    <div className="flex bg-black items-center justify-center min-h-screen font-fira-sans">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#b8ef43]"></div>
        <p className="mt-4 text-white/60">Loading...</p>
      </div>
    </div>
  );
};

export default LoadingFallback;
